import * as taskName from './task-name'

import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.ORDER_RETAINER,
    widgetList: [
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/retainer/order-retainer.js